import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export type ContentColumnStyleProps = {
  textChildren: 1 | 2 | 3;
};

const contentColumnBaseStyle = css`
  display: grid;
  grid-column-end: content;
  grid-column-start: content;
  grid-row-end: content;
  grid-row-start: content;
  .content-column-title-container,
  .content-column-subtitle,
  .content-column-tertiary-title {
    margin-top: ${theme.spacing(0.25)};
    margin-right: ${theme.spacing(0)};
    margin-bottom: ${theme.spacing(0.25)};
    margin-left: ${theme.spacing(0)};
  }
`;

const contentColumnTwoTextChildrenStyle = css`
  .content-column-subtitle {
    color: ${theme.font.colors.light || theme.font.colors.default};
  }
`;

const contentColumnThreeTextChildrenStyle = css`
  .content-column-subtitle {
    color: ${theme.font.colors.default};
  }
  .content-column-tertiary-title {
    color: ${theme.font.colors.light || theme.font.colors.default};
    margin-top: 0;
    margin-right: 0;
    margin-bottom: 0;
    margin-left: 0;
  }
`;

export const contentColumnStyles = ({ textChildren }: ContentColumnStyleProps) =>
  cx(
    contentColumnBaseStyle,
    textChildren === 2 && contentColumnTwoTextChildrenStyle,
    textChildren === 3 && contentColumnThreeTextChildrenStyle
  );
